<template>
  <DashboardWidget class="widget-line-stack" :loading="loading" :title="title">
    <v-chart :options="chart" :autoresize="true" />
  </DashboardWidget>
</template>

<script>

import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';

export default {
  name: 'dashboard-widget-line-stack',
  components: {
    DashboardWidget: () => import('../DashboardWidget'),
    'v-chart': ECharts,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    dataY: {
      type: Array,
      required: true,
    },
    dataX: {
      type: Array,
      required: true,
    },
    legendData: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      loading: false,
      chart: {
        legend: {
          data: this.legendData,
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.dataX,
        },
        yAxis: {
          type: 'value',
        },
        series: this.dataY,
      },
    };
  },
};

</script>

<style lang="scss">

.widget-line-stack {
  .echarts {
    width: 100%;
    height: 100%;
  }
}

</style>
